import Rails from '@rails/ujs';
import { Controller } from 'stimulus';

export default class extends Controller {
  formTarget: HTMLFormElement;

  static get targets() {
    return ['form'];
  }

  submit(evt: Event) {
    Rails.handleRemote.call(this.formTarget, evt);
  }
}
